import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin,ScrollTrigger);

const wrapper = document.getElementsByClassName('wrapper')[0];
const pagetop = document.getElementsByClassName('pagetop')[0];
const contents = document.getElementsByClassName('contents')[0];

//ローディング
(function(){
    window.addEventListener('load',(e) => {
        let tl = gsap.timeline();
        const sp = 0.6;

        setPagetop();

        tl.to('.js-load-inner',{
            scaleY: 1,
            duration: sp,
            ease: Expo.easeIn
        }).to('.js-loader',{
            scaleY: 0,
            duration: sp,
            ease: Expo.easeOut,
            delay: 0.2
        })

    });

    const setPagetop = () => {
        let scrollY = window.scrollY || window.pageYOffset;
        if(scrollY <= 200) {
            pagetop.classList.remove('show');
        } else {
            pagetop.classList.add('show');

        }

    }

    window.addEventListener('scroll',(e) => {
        setPagetop();
    });

})();

//メニューボタン
(function() {
    const menuButton = document.getElementsByClassName('js-menu')[0],
         gnav = document.getElementsByClassName('js-gnav')[0];
    menuButton.addEventListener('click',(e) => {
        e.preventDefault();
        if(wrapper.classList.contains('show-menu')) {
            wrapper.classList.remove('show-menu');

        } else {
            wrapper.classList.add('show-menu');
        }



    });

})();

//モーダルボタン
(function() {
    const modalButton = document.getElementsByClassName('js-modal-button'),
            modal = document.getElementsByClassName('modal')[0],
            modalBG = document.getElementsByClassName('modal__bg')[0];
    let win = null;
    for(let i = 0;i<modalButton.length;i++) {
        const m = modalButton[i];
        m.addEventListener('click',(e) => {
            e.preventDefault();
            const target = e.currentTarget;
            win = document.getElementById(target.getAttribute('href'));
            openModal();
        });
    }

    const openModal = () => {
        let tl = gsap.timeline();
        modal.style.display = 'block';

        tl.to(modalBG,{
            opacity: 1,
            duration: 0.5
        })
        .to(win,{
            opacity: 1,
            scale: 1,
            duration: 0.5,
            delay: -.3,
            ease: Expo.easeOut,
            onComplete: () => {
                modalBG.addEventListener('click',closeModal);
            }
        })

    }

    const closeModal = () => {
        modalBG.removeEventListener('click',closeModal);
        let tl = gsap.timeline();
        tl.to(modalBG,{
            opacity: 0,
            duration: 0.5
        }).to(win,{
            opacity: 0,
            scale: 0.9,
            duration: 0.5,
            delay: -0.5,
            onComplete: () => {
                modal.setAttribute('style','');
                modalBG.setAttribute('style','');
                win.setAttribute('style','');
            }

        });
    }

})();


//スタンプラリー切り替え
(function(){
    const typeButton = document.getElementsByClassName('js-type-button');
    let currentTag = document.getElementsByClassName('js-tag-qr')[0],
        currentType = 'qr';

        const shopInfoButton = document.querySelector('.js-shop-info');
    for(let i = 0 ; i< typeButton.length;i++) {
        const t = typeButton[i];
        t.addEventListener('click',(e) => {
            const target = e.currentTarget;
            const type   = target.getAttribute('data-type');
            const tag = document.getElementsByClassName('js-tag-' + type)[0];

            if(type === currentType) return;
            currentTag.classList.remove('current');
            tag.classList.add('current');

            typeSwitch(type);

            currentTag = tag;


        });
    }

    const typeSwitch = (type) => {
        const prevTarget = document.getElementsByClassName('stamprally-'+currentType);
        const nextTarget = document.getElementsByClassName('stamprally-' + type);
        let tl = gsap.timeline();
        shopInfoButton.setAttribute('href','#SpotLists_' + type);

        tl.to(['.stamprally-' + currentType,'.chronology'],{
            opacity: 0,
            duration: 0.5,
            onComplete: () =>{
                for(let i = 0;i<prevTarget.length;i++) {
                    prevTarget[i].style.display = 'none';
                    nextTarget[i].style.display = 'block';
                    nextTarget[i].style.opacity = '0';
                }
                contents.classList.remove('contents-' + currentType);
                contents.classList.add('contents-' + type);
                currentType = type;
            }
        })
        .to(['.stamprally-' + type,'.chronology'],{
            opacity: 1,
            duration: 0.5
        });

    }

})();

//よくある質問
(function(){
    const question = document.getElementsByClassName('js-question'),
          sp       = 0.6;
    for(let i = 0; i<question.length;i++) {
        let q = question[i];
        q.addEventListener('click',(e) => {
            const target = e.currentTarget;
            if(target.classList.contains('show')) {
                target.classList.remove('show');
                gsap.to(target.nextElementSibling,{
                    height: 0,
                    duration: sp,
                    ease: Expo.easeInOut
                })
            } else {
                target.classList.add('show');
                gsap.to(target.nextElementSibling,{
                    height: 'auto',
                    duration: sp,
                    ease: Expo.easeInOut
                })

            }


        });
    }

})();

//スムーズスクロール
(function(){
    const scrollButton = document.querySelectorAll('a[href^="#"]');
    for(let i = 0;i < scrollButton.length;i++) {
        scrollButton[i].addEventListener('click',(e)=>{
            e.preventDefault();
            wrapper.classList.remove('show-menu');
            let href = e.currentTarget.getAttribute('href'),
                target = document.getElementById(href.replace('#','')),
                top = target.getBoundingClientRect().top,
                offset = window.pageYOffset,
                position = top + offset;
                //position = href === '#Top' ? top + offset : top + offset - getHeight(target);
                gsap.to(window,{
                    duration: .6,
                    ease: Sine.easeOut,
                    scrollTo: {
                      y: position,
                      autoKill: false
                    }
                  });
        },false);
    }
})();